/**
 * @generated SignedSource<<3446d2a6d83f3c635e64d4fb26d989d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionStatus = "GENERATING_DOI" | "IDLE";
export type DatasetDOISubscription$variables = {
  datasetVersionId: string;
};
export type DatasetDOISubscription$data = {
  readonly datasetVersionUpdate: {
    readonly datasetVersion: {
      readonly " $fragmentSpreads": FragmentRefs<"DatasetDOIFragment">;
    };
    readonly status: DatasetVersionStatus;
  };
};
export type DatasetDOISubscription = {
  response: DatasetDOISubscription$data;
  variables: DatasetDOISubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "datasetVersionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "datasetVersionId",
    "variableName": "datasetVersionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetDOISubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersionUpdate",
        "kind": "LinkedField",
        "name": "datasetVersionUpdate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "datasetVersion",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DatasetDOIFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DatasetDOISubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersionUpdate",
        "kind": "LinkedField",
        "name": "datasetVersionUpdate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DatasetVersion",
            "kind": "LinkedField",
            "name": "datasetVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DOI",
                "kind": "LinkedField",
                "name": "doi",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "full",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "short",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4d6eac7c0a60dd20f12ef1f2007dd13",
    "id": null,
    "metadata": {},
    "name": "DatasetDOISubscription",
    "operationKind": "subscription",
    "text": "subscription DatasetDOISubscription(\n  $datasetVersionId: ID!\n) {\n  datasetVersionUpdate(datasetVersionId: $datasetVersionId) {\n    status\n    datasetVersion {\n      ...DatasetDOIFragment\n      id\n    }\n  }\n}\n\nfragment DatasetDOIFragment on DatasetVersion {\n  id\n  doi {\n    full\n    short\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d2386aae7817d59c9347b3e226c3597";

export default node;
